import React, { PropsWithChildren } from "react";
//#region types
import { WidgetBannerProps } from "models/propTypes/messagePropTypes";
//#endregion
//#region components
import { Grid, Hidden } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const WidgetBanner: React.FC<PropsWithChildren<WidgetBannerProps>> = ({
  image,
  imageHidden,
  className,
  onClick,
  title,
  message,
  children,
}) => {
  return (
    <Grid item container className={clsx(cssExports.stateBannerContainer, className)} direction="row" onClick={onClick}>
      <Hidden
        lgDown={imageHidden === "lgDown"}
        mdDown={imageHidden === "mdDown"}
        smDown={imageHidden === "smDown"}
        xsDown={imageHidden === "xsDown"}
      >
        <Grid item className={cssExports.bannerImgContainer}>
          {image}
        </Grid>
      </Hidden>
      <Grid item xs className={cssExports.bannerActionsContainer}>
        {title && (
          <Grid container className={cssExports.bannerHeaderText}>
            {title}
          </Grid>
        )}
        {message && (
          <Grid container className={cssExports.bannerDescription}>
            {message}
          </Grid>
        )}
        {children}
      </Grid>
    </Grid>
  );
};

export default WidgetBanner;
